import { useCallback } from 'react';
import { useGetStreamData } from '../useGetStreamData';

export const useUpdateMapInfo = () => {
	const { getStreamData } = useGetStreamData();

	const updateMapInfo = useCallback(
		(prevState, stream) => {
			const map = prevState.map;

			if (stream['/brain/osm_file']) {
				map.osmFile = getStreamData(stream, '/brain/osm_file');
			}

			return map;
		},
		[getStreamData],
	);

	return { updateMapInfo };
};
